import { gsap, SplitText, ScrollTrigger } from "@gsap";
/**
 * Layout: Tickets
 * Slug: tickets
 */

const mobileQuery = window.matchMedia("(max-width: 767px)");

function setHeights(ticketTypes, priceNumbers, priceToggle, priceHeaders) {
	// Mobile stacks each tier as a card, so the rows don't need to line up
	if (mobileQuery.matches) {
		[...priceNumbers, ...priceHeaders, priceToggle].forEach((el) => el.style.height = "");
		return;
	}

	const typeHeightsByIndex = {};
	ticketTypes.forEach((ticketType) => {
		const index = ticketType.dataset.index;
		typeHeightsByIndex[index] = ticketType.offsetHeight;
	});

	priceNumbers.forEach((price) => {
		const matchingHeight = typeHeightsByIndex[price.dataset.index];
		if (matchingHeight !== undefined) {
			price.style.height = matchingHeight + "px";
		}
	});

	const priceHeaderHeights = [];
	priceHeaders.forEach((priceHeader) => {
		priceHeaderHeights.push(priceHeader.offsetHeight);
	});
	const highestHeight = Math.max(...priceHeaderHeights) + "px";	
	priceHeaders.forEach((priceHeader) => {
		priceHeader.style.height = highestHeight
	});
	priceToggle.style.height = highestHeight;
}

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);

    const layouts = document.querySelectorAll('.flex-layout.tickets-layout');

	layouts.forEach((layout) => {
		const priceToggle = layout.querySelector(".price-toggle");
		const priceSwitch = priceToggle.querySelector(".slider");
		const priceHeaders = layout.querySelectorAll(".price-header");

		const ticketTypes = layout.querySelectorAll(".ticket-type");
		const priceNumbers = layout.querySelectorAll(".price");

		setHeights(ticketTypes, priceNumbers, priceToggle, priceHeaders);
		window.addEventListener("resize", () => {setHeights(ticketTypes, priceNumbers, priceToggle, priceHeaders)});
		window.addEventListener("load", () => {setHeights(ticketTypes, priceNumbers, priceToggle, priceHeaders)});

		const tierTabs = layout.querySelectorAll(".tier-tab");
		const priceCols = layout.querySelectorAll(".price-col");

		tierTabs.forEach((tab) => {
			tab.addEventListener("click", () => {
				tierTabs.forEach((otherTab) => {
					otherTab.classList.toggle("is-active", otherTab === tab);
					otherTab.setAttribute("aria-selected", otherTab === tab ? "true" : "false");
				});
				priceCols.forEach((priceCol) => {
					priceCol.classList.toggle("is-active", priceCol.dataset.tier === tab.dataset.tier);
				});
			});
		});

		priceSwitch.addEventListener("click", (e) => {
			layout.querySelector(".table-col").classList.toggle("package");
		});

		gsap.from(layout.querySelectorAll(".price-col"), {
			opacity: 0,
			y: -30,
			stagger: 0.2,
			duration: 0.5,
			scrollTrigger: {
				trigger: layout.querySelector(".table-col .table-container"),
				scrub: false,
				start: "top bottom-=25%",
				end: "bottom center",
			}
		})
	});

});
